import axios from "axios";

export const api = axios.create({
    baseURL:
        process.env.NODE_ENV === "production"
            ? "https://api.syncbooks.co.uk"
            : "http://localhost:3001",
    withCredentials: true,
});
